import { SECTION } from "./sections";

const ACCOUNT_MENU = ["account-menu"];

export const NAV_LINKS = Object.freeze([
  {
    id: "faq",
    label: "FAQ",
    iconName: "LiveHelpOutlined",
    section: SECTION.UTILITY,
    contexts: ACCOUNT_MENU,
    href: "/faq",
    newTab: true,
  },
  {
    id: "log-out",
    label: "Log Out",
    iconName: "ExitToAppOutlined",
    section: SECTION.UTILITY,
    contexts: ACCOUNT_MENU,
    routeId: "logout",
  },
]);
